import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SRLE（食い倒れ冒険） */
const srleContent: DiagnosisResultContent = {
  code: 'SRLE',
  name: '食い倒れ冒険',
  catchphrase: '屋台で謎の料理を食べて、五感フル稼働の食い倒れ冒険',
  rarity: 5,
  style:
    '「腹が減ったら、その場で冒険」が信条の食いしん坊。計画は立てず、匂いと勘を頼りに路地裏や屋台へ分け入る。のんびりした足取りで、現地の人に混じって未知の味を楽しむ。観光より「食の発見」が主目的で、失敗も含めて全部おいしい。土地の食文化に体当たりで飛び込む、生粋のグルメ冒険家タイプ。',
  strengths: [
    { lead: '食の嗅覚が鋭い', text: 'ガイドに載らない名店を勘で見つけ出せる。' },
    { lead: '飛び込み力が高い', text: '言葉が通じなくても現地の食に物怖じせず挑める。' },
    { lead: '体験の濃さが格別', text: '土地の人と混じって食べるため、記憶に深く残る。' },
  ],
  weaknesses: [
    { lead: '当たり外れがある', text: '下調べなしゆえ、ハズレを引くこともしばしば。' },
    { lead: '衛生・安全のリスク', text: '勢いで攻めるため、体調管理が課題になりやすい。' },
    { lead: '同行者を選ぶ', text: '冒険的すぎて、慎重派とはペースが合いにくい。' },
  ],
  aaru: [
    { icon: 'utensils', text: '地元民で賑わう店に突撃' },
    { icon: 'msg', text: '「あの匂い、行ってみよう」が口癖' },
    { icon: 'utensils', text: 'メニューが読めなくても注文' },
    { icon: 'camera', text: '屋台の湯気を激写' },
  ],
  manual: {
    good: '冒険心に付き合う／未知の味を一緒に楽しむ',
    ng: '「無難な店にしよう」とブレーキをかける',
    tips: '胃薬を常備しておくと冒険を全力で楽しめる',
  },
  compatibility: {
    good: 'SALE（即興仲間）／PALE（食仲間）',
    conflict: 'PACZ（安心計画）／PRCZ（快適派）',
    tips: '1食は無難な店を挟むと慎重派とも噛み合う',
  },
  destinations: {
    domestic: '大阪（路地裏の食い倒れ）／沖縄（市場と食堂文化）',
    overseas: 'ベトナム（屋台の宝庫）／タイ（屋台文化の本場）',
  },
};

export const srleDiagnosisResult = buildDiagnosisResult(srleContent);
